import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
})
export class TooltipComponent {
  @Input() substantiation: {
    name: string;
    description?: string;
    details?: string;
    subtype?: string;
    geography?: string;
  };

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(): void {
    // Trigger change detection when input changes
    this.cdr.detectChanges();
  }

  ngOninit() {
    //this.cdr.detectChanges();
    console.log(this.substantiation, 'tootip data');
  }
  /**to sanitize html elements */
  sanitizeHTML(content: string): SafeHtml {
    const div = document.createElement('div');
    div.innerHTML = content;
    return div.textContent || div.innerText || '';
  }
}
